// deps
import React, { Fragment } from "react";
import { StyleSheet, css } from "aphrodite";

// components
import Text from "../Text";
import { IconAvatarO } from "@cloudspire/legacy-svg-icon-library";

// libraries
import { emToPx } from "../../libraries";

// constants
import theming from "../../constants/theming";

const { useTheme } = theming;

const styles = StyleSheet.create({
  avatar: {
    width: emToPx(4),
    height: emToPx(4),
    borderRadius: "50%",
  },
});

function CustomerAvatar(props) {
  const { customer } = props;

  const theme = useTheme();

  return (
    <Fragment>
      {customer?.avatar?.small?.url ? (
        <img
          className={css(styles.avatar)}
          src={customer.avatar.small.url}
          alt={customer.firstname + " " + customer.lastname}
        />
      ) : (
        <Text
          style={{ fontSize: emToPx(4), color: theme.PRIMARY_COLOR_DARKEN }}
        >
          <IconAvatarO />
        </Text>
      )}
    </Fragment>
  );
}

export default CustomerAvatar;
